// import "./App.css"
// import Header from "./components/common/heading/Header"
// import { BrowserRouter as Router,Switch,Route} from "react-router-dom"
// import Home from "./components/home/Home"
// import About from "./components/about/About"
// import CourseHome from "./components/allcourses/CourseHome"
// //  import Gallery from "./components/Gallery/Gallery";
// import PrincipalDesk from './components/Principal/PrincipalDesk';
// import AdmissionForm from './components/Admission/AdmissionForm';
// import EnrollForm from './components/Admission/EnrollForm';
// import LocateUs from "./components/LocateUs/LocateUs";

// function App(){
//   return (
//    <>
//     <Router>

//     <Header/>
//     <Switch>

//     <Route path='/'exact component ={Home}/>
//     <Route path='/about'exact component ={About}/>
//     <Route path='/courses'exact component ={CourseHome}/>
//     {/* <Route path="/gallery" exact  component ={<Gallery />} /> */}
//     <Route path="/principal-desk" exact component={PrincipalDesk} />
//     <Route path="/admission" exact component={AdmissionForm} />
//         <Route path="/enroll" exact component={EnrollForm} />
//         {/* { <Route path="/gallery" component={Gallery} /> } */}

//         <Route path="/LocateUs" exact component={LocateUs} />

//     </Switch>
//     </Router>
//     </>
//   )
// }

// export default App


// import "./App.css";
// import Header from "./components/common/heading/Header";
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import React, { Suspense, lazy } from "react";

// // Lazy-loaded components for performance
// const Home = lazy(() => import("./components/home/Home"));
// const About = lazy(() => import("./components/about/About"));
// const CourseHome = lazy(() => import("./components/allcourses/CourseHome"));
// const PrincipalDesk = lazy(() => import("./components/Principal/PrincipalDesk"));
// const AdmissionForm = lazy(() => import("./components/Admission/AdmissionForm"));
// const EnrollForm = lazy(() => import("./components/Admission/EnrollForm"));
// const LocateUs = lazy(() => import("./components/LocateUs/LocateUs"));

// function App() {
//   return (
//     <Router>
//       <Header />
//       <Suspense fallback={<div className="loading">Loading...</div>}>
//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/about" element={<About />} />
//           <Route path="/courses" element={<CourseHome />} />
//           <Route path="/principal-desk" element={<PrincipalDesk />} />
//           <Route path="/admission" element={<AdmissionForm />} />
//           <Route path="/enroll" element={<EnrollForm />} />
//           <Route path="/locate-us" element={<LocateUs />} />
//           <Route path="*" element={<h1 className="error-page">404 - Page Not Found</h1>} />
//         </Routes>
//       </Suspense>
//     </Router>
//   );
// }

// export default App;


// import "./App.css";
// import Header from "./components/common/heading/Header";
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import React, { Suspense, lazy } from "react";

// // Lazy-loaded components for performance
// const Home = lazy(() => import("./components/home/Home"));
// const About = lazy(() => import("./components/About/About"));
// const CourseHome = lazy(() => import("./components/allcourses/CourseHome"));
// const PrincipalDesk = lazy(() => import("./components/Principal/PrincipalDesk"));
// const AdmissionForm = lazy(() => import("./components/Admission/AdmissionForm"));
// const EnrollForm = lazy(() => import("./components/Admission/EnrollForm"));
// const LocateUs = lazy(() => import("./components/LocateUs/LocateUs"));

// function App() {
//   return (
//     <Router>
//       <Header />
//       <Suspense fallback={<div className="loading">Loading...</div>}>
//         <Switch>
//           <Route path="/" exact component={Home} />
//           <Route path="/about" exact component={About} />
//           <Route path="/courses" exact component={CourseHome} />
//           <Route path="/principal-desk" exact component={PrincipalDesk} />
//           <Route path="/admission" exact component={AdmissionForm} />
//           <Route path="/enroll" exact component={EnrollForm} />
//           <Route path="/locate-us" exact component={LocateUs} />
//           <Route path="*">
//             <h1 className="error-page">404 - Page Not Found</h1>
//           </Route>
//         </Switch>
//       </Suspense>
//     </Router>
//   );
// }

// export default App;


// import "./App.css";
// import "./components/Global.css"
// import Header from "./components/common/heading/Header";
// // import Footer from "./components/footer/Footer";
// import Footer from "./components/Footer/Footer"; 
// import Chatbot from "./components/Chatbot/Chatbot";

// //import GlobalMarquee from "./components/marquee/GlobalMarquee"
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import React, { Suspense, lazy } from "react";
// const Home = lazy(() => import("./components/home/Home"));
// const About = lazy(() => import("./components/AboutSection/About"));
// const Gallery = lazy(() => import("./components/Gallery/Gallery"));
// const CourseHome = lazy(() => import("./components/allcourses/CourseHome"));
// const PrincipalDesk = lazy(() => import("./components/Principal/PrincipalDesk"));
// const AdmissionForm = lazy(() => import("./components/Admission/AdmissionForm"));
// const EnrollForm = lazy(() => import("./components/Admission/EnrollForm"));
// const LocateUs = lazy(() => import("./components/LocateUs/LocateUs"));
// const Contact =lazy(() => import("./components/Contact/Contact"));


// const Parents = lazy(() => import ("./components/Parents/ParentSection"));

// function App() {
//   return (
//     <Router>
//       <Header />
      
//       <Suspense fallback={<div className="loading">Loading...</div>}>
//         <Switch>
//           <Route path="/" exact component={Home} />
//           <Route path="/about" exact component={About} />
//           <Route path="/gallery" exact component={Gallery} />
//           <Route path="/courses" exact component={CourseHome} />
//           <Route path="/principal-desk" exact component={PrincipalDesk} />
//           <Route path="/admission" exact component={AdmissionForm} />
//           <Route path="/enroll" exact component={EnrollForm} />
//           <Route path="/LocateUs" exact component={LocateUs} />
//           <Route path ="/Contact"  exact component={Contact}/>
//           <Route path ="/Parents"  exact component={Parents}/>
//           <Route path="*">
//             <h1 className="error-page">404 - Page Not Found</h1>
//           </Route>
//         </Switch>
//       </Suspense>
//       <Footer />  
//       <Chatbot />
//     </Router>
//   );
// }

// export default App;


import "./App.css";
import "./components/Global.css";
import Header from "./components/common/heading/Header";
import Footer from "./components/Footer/Footer"; 
import Chatbot from "./components/Chatbot/Chatbot";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import React, { Suspense, lazy } from "react";

const Home = lazy(() => import("./components/home/Home"));
const About = lazy(() => import("./components/AboutSection/About"));
const Gallery = lazy(() => import("./components/Gallery/Gallery"));
const CourseHome = lazy(() => import("./components/allcourses/CourseHome"));
const PrincipalDesk = lazy(() => import("./components/Principal/PrincipalDesk"));
const AdmissionForm = lazy(() => import("./components/Admission/AdmissionForm"));
const EnrollForm = lazy(() => import("./components/Admission/EnrollForm"));
const LocateUs = lazy(() => import("./components/LocateUs/LocateUs"));
const Contact = lazy(() => import("./components/Contact/Contact"));
const Parents = lazy(() => import("./components/Parents/ParentSection"));
const FeeStructure = lazy(() => import("./components/FeeStructure")); // ✅ Import FeeStructure

function App() {
  return (
    <Router>
      <Header />
      <Suspense fallback={<div className="loading">Loading...</div>}>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/about" exact component={About} />
          <Route path="/gallery" exact component={Gallery} />
          <Route path="/courses" exact component={CourseHome} />
          <Route path="/principal-desk" exact component={PrincipalDesk} />
          <Route path="/admission" exact component={AdmissionForm} />
          <Route path="/enroll" exact component={EnrollForm} />
          <Route path="/locateus" exact component={LocateUs} />
          <Route path="/contact" exact component={Contact} />
          <Route path="/parents" exact component={Parents} />
          <Route path="/Fee-structure" exact component={FeeStructure} /> ✅ New Route
          <Route path="*">
            <h1 className="error-page">404 - Page Not Found</h1>
          </Route>
        </Switch>
      </Suspense>
      <Footer />
      <Chatbot />
    </Router>
  );
}

export default App;
